import { render, staticRenderFns } from "./InsiderTipElement.vue?vue&type=template&id=2edd654a&"
import script from "./InsiderTipElement.vue?vue&type=script&lang=js&"
export * from "./InsiderTipElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports